/**
 * 研报
 */
 import React, { useEffect, useState } from "react"
 import { LoadStatus } from "../../load_status"
 import stock_info from "../../../../modules/stock_info/newweb"
 import { quotedata } from "../../quotedata"
 
export function StockReport(props: { quotedata: quotedata }) {
  const [stockReport, setStockReport] = useState([])
  const [currentPageStockReport, setCurrentPageStockReport] = useState([])
  const [loading, setLoading] = useState(false)
  const [pageNumber, setPageNumber] = useState(1)
  const [totalReport, setTotalReport] = useState(0)

  const openDetail = (infoId: string) => {
    location.href = `https://wap.eastmoney.com/report/${infoId}.html?code=${props.quotedata.code}&market=${props.quotedata.market}`
  }
  const loadMore = () => {
    setPageNumber(pageNumber+1)
  }

  const getStockReport = () => {
    const CHOICE_ZS = 47
    let market = props.quotedata.market
    let code = props.quotedata.code
    const isBK = props.quotedata.market == 90
    setLoading(true)

    if (isBK) {
      //板块特殊处理
      code = props.quotedata.code.substring(2).replace(/\b(0+)/ig,"")
    }
    if (props.quotedata.market == CHOICE_ZS) {
      code = "000001"
      market = 1
    }

    stock_info.getStockReports_new(code, market, pageNumber, 20, isBK).then((back: any) => {
      if (back.list && back.list.length) {
        if (pageNumber == 1) {
          setStockReport(back.list)
        } else {
          let temp = stockReport.concat(back.list)
          setStockReport(temp)
        }
        setTotalReport(back.total_hits)
        setCurrentPageStockReport(back.list)
        setLoading(false)
      }else{
        setCurrentPageStockReport([])
        setLoading(false)
      }
    })
  }
  

  useEffect(() => {
    getStockReport()
  }, [pageNumber])

  return (
    <>
      <ul className="report-list">
          {stockReport.length > 0 && stockReport.map((item: any) => {
            return (
              <li key={item.art_code}>
                <a>
                  <div className="tit" onClick={() => openDetail(item.art_code)}>
                    {item.title}
                  </div>
                  <p className="time">{item.publish_time.substring(0, 10)}</p>
                </a>
              </li>
            )
          })}
        </ul>
      {loading && <LoadStatus icon={true} title="数据加载中..." className="com_tips" />}
      {!loading && stockReport.length == 0 && totalReport == 0 && <LoadStatus icon={false} title="暂无数据" className="com_tips" />}
      {stockReport.length > 0 && stockReport.length == totalReport && <LoadStatus icon={false} title="到底了" className="com_tips" />}
      {stockReport.length < totalReport && currentPageStockReport.length == 20 && (
        <div
          className="comm-more"
          onClick={(e) => {
            e.preventDefault()
            loadMore()
          }}
        >
          <a href="#">加载更多</a>
        </div>
      )}
    </>
  )
}
